<template>
  <div>
    <v-card class="ma-2 pt-0">
      <v-card-title class="pb-0">
        Order List<v-btn class="ma-2" icon small @click="outsideBarCode=true;barcodeDialog = true;">
          <v-icon>control_camera</v-icon>
        </v-btn>
        <v-btn class="ma-2" icon small @click="outsideBarCode=false;barcodeDialog = true;">
          <v-icon>camera_enhance</v-icon>
        </v-btn>
        <v-btn class="ma-2" icon small @click="dialogDeletePhoto=true" v-if="token.role!='DELIVERY'">
          <v-icon>delete</v-icon>
        </v-btn>
        <v-btn class="ma-2" icon small @click="dialogPhone=true" v-if="token.role!='DELIVERY'">
          <v-icon>phone</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed fab small color="primary" outlined>
          <v-icon>help</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <v-col cols="12" md="2" class="px-2 pt-3">
            <v-select
              label="Status"
              v-model="status"
              :items="listStatus"
              @change="changeFindBy"
              hide-details
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" md="2" class="px-2 pt-3">
            <v-select
              label="Find By"
              v-model="action"
              hide-details
              :items="listAction[status]"
              dense
            />
          </v-col>
          <v-col cols="12" md="2" class="px-2 pt-3">
            <v-menu
              :close-on-content-click="false"
              transition="scale-transition"
              min-width="290px"
              v-model="fromMenu"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="fromDateValue"
                  label="From Date"
                  prepend-icon="event"
                  hide-details
                  readonly
                  v-on="on"
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                :type="datePickerType"
                v-model="fromDate"
                @input="fromMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="2" class="px-2 pt-3">
            <v-menu
              :close-on-content-click="false"
              transition="scale-transition"
              min-width="290px"
              v-model="toMenu"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="toDateValue"
                  label="To Date"
                  prepend-icon="event"
                  hide-details
                  readonly
                  v-on="on"
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                :type="datePickerType"
                v-model="toDate"
                @input="toMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="1" class="text-md-center text-right pt-2">
            <v-btn fab small depressed color="primary" @click="search">
              <v-icon>search</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" md="3" class="text-right px-2 pt-3">
            <v-text-field
              v-model="textSearch"
              label="Search"
              hide-details
              dense
              append-icon="search"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="ma-2">
      <v-card-text class="pa-0">
        <v-data-table
          class="tbl-info"
          :headers="headers"
          :items="orderList"
          :items-per-page="-1"
          fixed-header
          mobile-breakpoint="sm"
          :headers-length="14"
          :search="textSearch"
          height="73vh"
          hide-default-footer
        >
          <template
            v-slot:body="{ items, pagination }"
            v-if="orderList.length > 0"
          >
            <tbody>
              <tr v-for="item in items" :key="item.name"
              :style="{backgroundColor: (item.statusDate == 'Completed' ? '#bfffc8' : 'transparent' ) }">
                <td class="text-center">{{ item.itemId }}
                </td>
                <td class="text-center"><h3>{{ item.code }}</h3>
                </td>
                <td class="red--text text-center">{{ item.statusDate }}</td>
                <td class="text-center">{{ item.date | removeTime }}</td>
                <td>
                  <v-row>
                     <v-col
            v-for="rest in item.restList"
                  :key="rest.restaurantId"
                  cols="6"
                  md="6"
          >
                  {{ rest.restName }}
                  <v-btn
                    @click="getRestaurantPhoto(item,rest)"
                    text
                    icon
                    x-small
                    color="primary"
                  >
                    <v-icon>insert_photo</v-icon>
                  </v-btn>
                  <v-btn
                    @click="getRestaurantSign(item,rest)"
                    text
                    icon
                    x-small
                    color="primary"
                  >
                    <v-icon>touch_app</v-icon>
                  </v-btn>
                  <v-btn
                    @click="getRestaurantDetail(rest)"
                    text
                    icon
                    x-small
                    color="primary"
                  >
                    <v-icon>visibility</v-icon>
                  </v-btn>
                    </v-col>
                  </v-row>
                </td>
                <td>
                  {{item.customerName}}
                                    <v-btn
                    @click="getCustomerByItemId(item.itemId)"
                    text
                    icon
                    x-small
                    color="primary"
                  >
                    <v-icon>visibility</v-icon>
                  </v-btn>
                  
                </td>
                <!-- <td>{{ item.toBranchName }}</td> -->
                <!-- <td>{{item.fromTownshipName}}</td> -->                
                <!-- <td>{{ item.phone }}</td>
                <td>{{ item.address }}</td> -->
                <td>{{ item.assignName}}</td>
                <!-- <td>{{ item.toTownshipName }}</td> -->
                <!-- <td class="text-right blue--text"><h4>{{ item.osPaid|defaultPaymentFormat }}</h4></td> -->
                <td class="text-right blue--text"><h4>{{ item.itemValue|defaultPaymentFormat }}</h4></td>
                <td class="text-right blue--text"><h4>{{ item.deliAmount|defaultPaymentFormat }}</h4></td>
                <td class="text-right red--text"><h4>{{ item.payment|defaultPaymentFormat }}</h4></td>
                <td class="text-center" v-if="item.mainMenu==0" ><a @click="clickMainMenu(item)">Doing</a></td>
                <td class="text-center" v-else ><a text @click="clickMainMenu(item)">Done</a></td>
                <td class="text-center">{{ item.collectedRemark }}</td>
                <td class="text-center">
                  
                  <v-btn
                        @click="clickGate(item)"
                        text
                        x-small
                        color="primary"
                        outlined
                      >Gate
                      </v-btn> 
                      <v-btn
                      class="mt-1"
                        @click="clickItemSimple(item)"
                        text
                        x-small
                        color="primary"
                        outlined
                      >Item
                      </v-btn> </td>
                <td class="text-center">
                  <!-- <v-btn
                        @click="clickPhoto(item.itemId)"
                        text
                        icon
                        small
                        color="primary"
                      >
                        <v-icon>looks_one</v-icon>
                      </v-btn> -->
                      <!-- <v-btn
                        @click="clickSignOs(item)"
                        text
                        icon
                        small
                        color="primary"
                      >
                        <v-icon>gesture</v-icon>
                      </v-btn> -->
                  <v-btn
                        @click="clickAssign(item)"
                        text
                        icon
                        small
                        color="primary"
                      >
                        <v-icon>looks_two</v-icon>
                      </v-btn>
                      <v-btn
                        @click="clickSignCustomer(item)"
                        text
                        icon
                        small
                        color="primary"
                      >
                        <v-icon>border_color</v-icon>
                      </v-btn>
                      <v-btn icon small  color="primary" @click="clickHistory(item)">
                    <v-icon>history</v-icon>
                  </v-btn>
                  <v-btn
                    @click="printPreview(item)"
                    color="black"
                    class="mx-1"
                    small
                    icon
                    text
                  >
                    <v-icon>print</v-icon>
                  </v-btn>
                  <!-- <v-btn
                    @click="changeGroupRouter(item)"
                    color="primary"
                    class="mx-1"
                    small
                    icon
                    text
                    v-if="token.role!='DELIVERY'"
                  >
                    <v-icon>add</v-icon>
                  </v-btn> -->
                  <v-btn
                    @click="changeRouter(item)"
                    color="primary"
                    text
                    icon
                    small
                    v-if="token.role != 'DELIVERY' && (item.statusDate!='Completed' || token.role=='ADMIN') "
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <v-btn
                    @click="deleteItemById(item.itemId)"
                    color="red"
                    text
                    icon
                    small
                    v-if="token.role != 'DELIVERY' && (item.statusDate!='Completed' || token.role=='ADMIN') "
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                </td>
              </tr>
              <tr>
                <td colspan="10">{{ items | groupStatus }}</td>
                <td class="subtitle-2">{{ items | priceTotal }}</td>
                <td colspan="3" class="subtitle-2">
                  Total Way : {{ pagination.itemsLength }} >
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-row no-gutters>
      <v-col>
        <v-dialog v-model="osDialog" width="400">
          <v-card>
            <v-card-title 
              >Restaurant Information</v-card-title
            >
            <v-card-text>
              <v-row no-gutters>
                <v-col cols="8" md="8">
                  <h3>{{osInfo.restName}}</h3>
                </v-col>
                <v-col cols="4" md="4">
                  {{osInfo.restPhone}}
                </v-col>
                <v-col cols="6" md="6">
                  {{osInfo.restAddress}}
                </v-col>
                <v-col cols="12" md="12">
                  <v-simple-table
      :fixed-header="true" dense class="elevation-1">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-center white--text primary">No.</th>
            <th class="text-center white--text primary"><v-divider vertical></v-divider></th>
            <th class="text-center white--text primary">Item Name</th>
            <th class="text-center white--text primary"><v-divider vertical></v-divider></th>
            <th class="text-center white--text primary">Qty</th>
          </tr>
        </thead>
        <tbody>
          <tr 
           v-for="(item,index) in osInfo.itemQtyList" :key="index" >
           <td class="text-center">{{ item.no }}</td>
            <td class="text-center"><v-divider vertical></v-divider></td>
            <td>{{ item.itemName }}</td>
            <td class="text-center"><v-divider vertical></v-divider></td>
            <td class="text-right">{{ item.qty}}</td>
          </tr>
          <v-divider></v-divider>
        </tbody>
      </template>
 </v-simple-table>
                </v-col>
                <v-col cols="6" md="6" class="mt-3">
                    <h3>Amount</h3>
                </v-col>
                <v-col cols="6" md="6" class="mt-3">
                  <h3>= {{osInfo.restAmount|defaultPaymentFormat}}</h3>
                </v-col>
                <v-col cols="6" md="6">
                    <h3>Discount</h3>
                </v-col>
                <v-col cols="6" md="6">
                    <h3>= {{osInfo.restDiscount|defaultPaymentFormat}}(%)</h3>
                </v-col>
                <v-col cols="6" md="6">
                    <h3>DisAmount</h3>
                </v-col>
                <v-col cols="6" md="6">
<h3>= {{osInfo.restDisAmount|defaultPaymentFormat}}</h3>
                </v-col>
                <v-col cols="6" md="6">
                    <h3>Total</h3>
                </v-col>
                <v-col cols="6" md="6">
<h3>= {{osInfo.restTotal|defaultPaymentFormat}}</h3>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="customerInfoDialog" width="600">
          <v-card>
            <v-card-title class="headline" primary-title dark
              >Customer Information</v-card-title
            >
            <v-card-text>
              <v-row no-gutters>
                <v-col cols="5">
                  <v-text-field
                    readonly
                    label="CustomerName"
                    v-model="customerInfo.customerName"
                    prepend-icon="person"
                  />
                </v-col>
                <v-col cols="5" offset="1">
                  <v-text-field
                    v-model="customerInfo.itemName"
                    prepend-icon="more"
                    label="ItemName"
                    rows="3"
                    readonly
                  />
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="3">
                  <v-text-field
                    v-model="customerInfo.phone"
                    prepend-icon="phone"
                    label="Phone"
                    readonly
                  />
                </v-col>
                <v-col cols="3" offset="1">
                  <v-text-field
                    v-model="customerInfo.weight"
                    prepend-icon="local_offer"
                    label="Weight"
                    readonly
                  />
                </v-col>
                <v-col cols="3" offset="1">
                  <v-text-field
                    v-model="customerInfo.code"
                    prepend-icon="code"
                    label="Code"
                    readonly
                  />
                </v-col>
                <v-col cols="6">
                  <v-textarea
                    v-model="customerInfo.address"
                    prepend-icon="location_city"
                    label="Address"
                    readonly
                    rows="2"
                  />
                </v-col>
                <v-col offset="1" cols="5">
                  <v-textarea
                    v-model="customerInfo.remark"
                    prepend-icon="description"
                    label="Remark"
                    rows="2"
                    readonly
                  />
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="6">
                  <v-textarea
                    v-model="customerInfo.collectRemark"
                    prepend-icon="description"
                    label="Collect Reamark"
                    rows="2"
                    readonly
                  />
                  <v-textarea
                    v-model="customerInfo.assignRemark"
                    prepend-icon="description"
                    label="Assign Remark"
                    rows="2"
                    readonly
                  />
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="6">
                  <v-checkbox
                    v-model="customerInfo.osPayment"
                    label="OsPayment"
                    readonly
                  />
                </v-col>
                <v-col cols="6">
                  <v-checkbox
                    v-model="customerInfo.customerPayment"
                    label="CustomerPayment"
                    readonly
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-col>
      <v-dialog transition="dialog-top-transition" v-model="barcodeDialog" width="450">
        <v-card>
          <v-card-title class="headline" primary-title dark
            >Scan QR Code</v-card-title
          >
          <v-card-text>
            <v-row no-gutters>
              <v-col>
                <bar-code-view
                  :dialogStatus="barcodeDialog"
                  :barCodeReceive="barCodeReceive"
                  :outsideBarCode="outsideBarCode"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
       <v-dialog
        v-model="dialogPayment"
        max-width="400"
        transition="dialog-top-transition"
      >
        <paymentDialog
          @closeDialog="dialogPayment = false"
          :itemId = "itemId"
          :transactionId = "transactionId"
          :photoIndex = "photoIndex"
        />
      </v-dialog>
      <v-dialog
        v-model="dialogDeletePhoto"
        max-width="400"
        transition="dialog-top-transition"
      >
      <v-card>
        <v-card-title>To delete Photos</v-card-title>
     
      <v-card-text>
        <v-text-field v-model="photoId" label="Collected Photo Id" type="number"/>
        <v-text-field v-model="assignedId" label="Payment Photo Id" type="number"/>
        <v-text-field v-model="notiId" label="Noti Photo Id" type="number"/>
        <v-text-field v-model="signOsId" label="Signature Restaurant" type="number"/>
        <v-text-field v-model="signCustId" label="Signature Customer" type="number"/>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="clickOKDeletePhoto()">OK</v-btn>
      </v-card-actions>
         </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogPhone"
        max-width="400"
        transition="dialog-top-transition"
      >
      <v-card>
        <v-card-title>To find Phone number</v-card-title>
      <v-card-text>
        <v-text-field v-model="phonenumber" label="Customer Phone Number" type="number"/>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="clickPhoneNo()">OK</v-btn>
      </v-card-actions>
         </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogSignature"
        max-width="400"
        transition="dialog-top-transition"
      >
      <v-card>
        <v-card-title>Signature {{signTitle}}</v-card-title>
      <v-card-text>
        <v-img :src="signfile"/>
      </v-card-text>
         </v-card>
      </v-dialog>
      <v-bottom-sheet v-model="dialogOsHistory" fullscreen scrollable>
        <v-sheet class="fullscreen">
          <orderHistoryDialog
            @closeDialog="dialogOsHistory=false"
            :orderId = "orderId"
            :refreshId="refreshId"
          />
        </v-sheet>
      </v-bottom-sheet>
    </v-row>
  </div>
</template>
<script>
import orderService from "../service/OrderService";
import employeeService from "../service/EmployeeService";
import onlineShopService from "../service/OnlineshoppingService";
import BarCodeScanView from "../components/BarCodeScanView";
import paymentDialog from "@/components/PaymentPhotoDialog.vue";
import axios from "../config";
import orderHistoryDialog from "@/components/OrderHistoryDialog.vue";
export default {
  beforeMount: function () {
    this.token = this.$store.state.userAccount;
    let status = this.$route.query.status;
    if (status == undefined) {
      status = "ALL";
    }
    this.status = status;
    let action = this.$route.query.action;
    if (action == undefined) {
      action = "SaleDate";
    }
    this.action = action;
    let fromDate = this.$route.query.fromDate;
    if (fromDate == undefined) {
      fromDate = new Date().toISOString().substr(0, 10);
    }
    this.fromDate = fromDate;
    let toDate = this.$route.query.toDate;
    if (toDate == undefined) {
      toDate = new Date().toISOString().substr(0, 10);
    }
    this.toDate = toDate;
    this.search();
    employeeService.getAllDelivery().then((data) => {
      this.listEmployee = this.listEmployee.filter((f) => false);
      this.delivery = { profileName: "All", userAccountId: 0 };
      this.listEmployee.push(this.delivery);
      this.listEmployee.push(...data);
    });

    onlineShopService.getAllOnlineshopping().then((data) => {
      this.listOs = this.listOs.filter((f) => false);
      this.os = { osId: 0, name: "All" };
      this.listOs.push(this.os);
      this.listOs.push(...data);
    });
  },
  data() {
    return {
      dialogOsHistory:false,
      headers: [
        { text: "Id", value: "itemId" ,sortable: false},
        { text: "Code", value: "code",sortable: false},
        { text: "Status", value: "statusDate",sortable: false},
        { text: "Date", value: "date",sortable: false},
        // { text: "Modified", value: "modifiedDate",sortable: false },
        // { text: "From Branch", value: "fromBranchName",sortable: false },
        // { text: "To Branch", value: "toBranchName",sortable: false  }, 
        { text: "Restaurant Name", value: "osName",sortable: false },
        { text: "Customer", value: "customerName",sortable: false },
        // { text: "To Branch", value: "toBranchName" },        
        // { text: "Cust Phone", value: "phone",sortable: false },
        // { text: "Cust Address", value: "address",sortable: false },
        // { text: "Tws", value: "toTownshipName",sortable: false },
        { text: "Assign", value: "assignName",sortable: false },
        // { text: "Restaurant Paid", value: "osPaid",sortable: false },
        // { text: "Deli Amount", value: "deliAmount",sortable: false },
        // { text: "Item Value", value: "itemValue",sortable: false },
        { text: "Order Amount", value: "itemValue",sortable: false },
        { text: "Service", value: "deliAmount",sortable: false },
        { text: "Payment", value: "payment",sortable: false },
        { text: "Menu", value: "mainMenu",sortable: false },
         { text: "Remark", value: "remark",sortable: false },
        { text: "Gate/Item", value: "look",sortable: false },
        // { text: "Item", value: "itemName" },
        { text: "Action", value: "itemId", sortable: false },
      ],
      toDate: new Date().toISOString().substr(0, 10),
      fromDate: new Date().toISOString().substr(0, 10),
      toMenu: false,
      fromMenu: false,
      dateType: "date",
      datePickerType: "date",
      //listAction: ["Date", "ModifiedDate"],
      //listStatus: ["ALL", "COMPLETED", "ERROR"],
      listStatus: [
      "ALL",
        "NONE",
        "COLLECTED",
        "ASSIGNED",
        "REJECTED",
        "ACCEPTED",
        "ORDERED",
        "PICKUP",
        "DELIVERED",
        "COMPLETED",
        "RETURN",
        "ERROR",
      ],
      listAction: {
        ALL: ["ModifiedDate","SaleDate","RequestDate","CollectDate","DeliverDate"],
        COLLECTED: ["CollectedDate"],
        ASSIGNED: ["AssignDate"],
        DELIVERING: ["DeliverDate"],
        DELIVERED: ["DeliverDate"],
        COMPLETED: ["DeliverDate"],
        RETURN: ["DeliverDate"],
        ERROR: ["DeliverDate"],
      },
      status: "ALL",
      action: "SaleDate",
      orderList: [],
      osDialog: false,
      osInfo: {
        osId: 0,
        name: "",
        address: "",
        phone: "",
      },
      customerInfoDialog: false,
      customerInfo: {
        customerName: "",
        itemName: "",
        address: "",
        phone: "",
        code: "",
        weight: "",
        osPayment: true,
        customerPayment: true,
        remark: "",
        collectRemark: "",
        assignRemark: "",
      },
      textSearch: "",
      listEmployee: [],
      delivery: null,
      os: null,
      barcodeDialog: false,
      outsideBarCode: false,
      listOs: [],
      dialogPayment:false,
      itemId:0,
      dialogDeletePhoto:false,
      photoId:0,
      transactionId:0,
      assignedId:0,
      token:{},
      phonenumber:"",
      dialogPhone:false,
      notiId:0,
      signfile:"",
      dialogSignature:false,
      signTitle:"Restaurant",
      signOsId:0,
      signCustId:0,
      photoIndex:"",
      orderId:0,
      refreshId:0
    };
    
  },
  methods: {
    clickHistory:function(item){
      //this.restId = item.osId;
      this.dialogOsHistory = true;
      this.orderId = item.itemId;
      this.refreshId = Number(this.refreshId)+1;
    },
    clickMainMenu:function(item){
        orderService
        .updateMainMenu(item.itemId)
        .then((response) => {
          if(item.mainMenu=="0"){
            item.mainMenu = "DONE";
          }else{
            item.mainMenu = "0";
          }
        })
        .catch((error) => {
          this.$swal("Fail!", error.response.data.message, "error");
        });
    },
    clickGate:function(item){
      this.transactionId = 0;
      this.dialogPayment = true;
      this.itemId = item.itemId;
      this.photoIndex = "gate";
      
    },
    clickItemSimple:function(item){
      this.transactionId = 0;
      this.dialogPayment = true;
      this.itemId = item.itemId;
      this.photoIndex = "itemsimple";
    },
    getRestaurantSign:function(item,rest){
        if(rest.restaurantId==0){
          this.clickSignOs(item);
        }else{
      this.dialogSignature = true;
      this.signfile  = `${axios.defaults.baseURL}/restsign/${rest.restaurantId}.png`;
      this.signTitle = "Restaurant Sign";
        }
    },
    getRestaurantPhoto:function(item,rest){
        this.dialogPayment = true;
        if(rest.restaurantId==0){
          this.itemId = item.itemId;
          this.photoIndex = "item";
        }else{
          this.itemId = rest.restaurantId;
          this.photoIndex = "rest";
        }
    },
    clickSignOs:function(item){
      this.dialogSignature = true;
      this.signfile  = `${axios.defaults.baseURL}/signos/${item.itemId}.png`;
      this.signTitle = "Restaurant Sign";
    },
    clickSignCustomer:function(item){
      this.dialogSignature = true;
      this.signfile  = `${axios.defaults.baseURL}/signcust/${item.itemId}.png`;
      this.signTitle = "Customer";
    },
    clickPhoneNo:function(){
      this.dialogPhone = false;
      orderService
        .getfindPhone(this.phonenumber)
        .then((response) => {
          this.orderList.splice(0,this.orderList.length);
          this.orderList.push(...response);
        })
        .catch((error) => {
          this.$swal("Fail!", error.response.data.message, "error");
        });
    },
    clickAssign:function(item){
        this.itemId = 0;
        this.transactionId = item.transactionId;
        this.dialogPayment = true;
        this.photoIndex = "assigned"; 
    },
    clickOKDeletePhoto:function(){
      this.dialogDeletePhoto = false;
      if(this.photoId!='' && this.photoId>0){
      orderService
        .deleteOrderPhoto(this.photoId)
        .then((response) => {
         // this.$swal("Successful","Save,Photo is Success.", "success");
          this.$swal({
     title: "Successful",
     text: "Save,Photo is Success.",
     type: "success",
     timer: 500
     });
        })
        .catch((error) => {
          this.$swal("Fail!", error.response.data.message, "error");
        });
      }

      if(this.assignedId!='' && this.assignedId>0){
      orderService
        .deleteAssignPhoto(this.assignedId)
        .then((response) => {
         // this.$swal("Successful","Save,Photo is Success.", "success");
          this.$swal({
     title: "Successful",
     text: "Save,Photo is Success.",
     type: "success",
     timer: 500
     });
        })
        .catch((error) => {
          this.$swal("Fail!", error.response.data.message, "error");
        });
      }
      //notiId
      if(this.notiId!='' && this.notiId>0){
      orderService
        .deleteNotiPhoto(this.notiId)
        .then((response) => {
         // this.$swal("Successful","Save,Photo is Success.", "success");
          this.$swal({
     title: "Successful",
     text: "Save,Photo is Success.",
     type: "success",
     timer: 500
     });
        })
        .catch((error) => {
          this.$swal("Fail!", error.response.data.message, "error");
        });
      }

      if(this.signOsId!='' && this.signOsId>0){
      orderService
        .deletePhotoSignOs(this.signOsId)
        .then((response) => {
         // this.$swal("Successful","Save,Photo is Success.", "success");
          this.$swal({
     title: "Successful",
     text: "Save,Photo is Success.",
     type: "success",
     timer: 500
     });
        })
        .catch((error) => {
          this.$swal("Fail!", error.response.data.message, "error");
        });
      }
      if(this.signCustId!='' && this.signCustId>0){
      orderService
        .deletePhotoSignCustomer(this.signCustId)
        .then((response) => {
         // this.$swal("Successful","Save,Photo is Success.", "success");
          this.$swal({
     title: "Successful",
     text: "Save,Photo is Success.",
     type: "success",
     timer: 500
     });
        })
        .catch((error) => {
          this.$swal("Fail!", error.response.data.message, "error");
        });
      }
    },
     clickPhoto:function(itemId){
        this.dialogPayment = true;
        this.itemId = itemId;
        this.transactionId = 0;
    },
    printPreview: function(item){
      this.$router
          .push({
            name: "voucherPrint",
            query: {
              itemId: item.itemId,
            }
          })
          .catch(() => {});
    },
    changeGroupRouter: function (item) {
      this.$router
        .push({
          name: "manage-order-multiple",
          query: {
            itemId: item.itemId,
            step: 3,
          },
        })
        .catch(() => {});
    },
    formatDate: function (date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      if (this.dateType == "date") {
        // const [year, month, day] = date.split("-");
        return `${day}-${month}-${year}`;
      }
    },
    changeRouter: function (item) {
       let step = 0;
      if (item.statusDate == "Delivered") {
        step = "4";
      } else if (item.statusDate == "Collected") {
        // if (item.collectName == "") {
        //   step = 3;
        // } else {
          step = 3;
        //}
      } else if (item.statusDate == "Order") {
        step = 2;
      } else{
        step = 4;
      } 
      this.$router
        .push({
          name: "manage-order",
          query: {
            itemId: item.itemId,
            step: step,
          },
        })
        .catch(() => {});
    },
    search: function () {
      orderService
        .getCompletReturnList(
          this.fromDateValue,
          this.toDateValue,
          this.status,
          this.action
        )
        .then((data) => {
          this.orderList = this.orderList.filter((v) => false);
          this.orderList.push(...data);
          let query = {
            fromDate: this.fromDate,
            toDate: this.toDate,
            status: this.status,
            action: this.action,
          };
          this.$router
            .replace({ name: "delivery-report", query })
            .catch(() => {});
        });
    },
    getOsInfo: function (itemId) {
      orderService.getOsByOsName(itemId).then((data) => {
        this.osDialog = true;
        this.osInfo = data;
      });
    },
    getRestaurantDetail:function(rest){
      this.osDialog = true;
      var tempObj = {};
      tempObj.restName = rest.restName;
      tempObj.restPhone = rest.restPhone;
      tempObj.restAddress = rest.restAddress;
      tempObj.itemQtyList = rest.itemQtyList;
      tempObj.restAmount = rest.restAmount;
      tempObj.restDiscount = rest.restDiscount;
      tempObj.restDisAmount = rest.restDisAmount;
      tempObj.restTotal = Number(rest.restAmount)-Number(rest.restDisAmount);
      this.osInfo = Object.assign({},tempObj);
    },
    getCustomerByItemId: function (itemId) {
      orderService.getCustomerByItemId(itemId).then((data) => {
        this.customerInfoDialog = true;
        this.customerInfo = data;
      });
    },
    deleteItemById: function (itemId) {
      this.$swal({
        title: "Do you want to delete!",
        text: "If you delete, you cannot get data any More. Are you sure?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((value) => {
        console.log(value);
        if (value) {
          orderService.deleteItemById(itemId).then((data) => {
            this.$swal({
              title: "Delete success!",
              icon: "success",
            });
            this.search();
          });
        }
      });
    },
    changeFindBy: function () {
      this.action = this.listAction[this.status][0];
    },
    barCodeReceive: function (code) {
      if (this.outsideBarCode) {
        orderService.getOrderByCodeId(code).then((data) => {
          this.orderList = this.orderList.filter((v) => false);
          console.log(data);
          if (
            data != null &&
            data.length != 0 &&
            data[0].statusDate == "Block"
          ) {
            this.$swal({
              title: "Already Assign!",
              text: "Assign person " + data[0].assignName,
              icon: "warning",
              buttons: true,
              dangerMode: true,
            }).then((value) => {});
          } else if (
            data != null &&
            data.length != 0 &&
            data[0].statusDate == "OtherBranch"
          ) {
            this.$swal({
              title: "Your branch is not same with to branch!",
              text: "To branch name " + data[0].toBranchName,
              icon: "warning",
              buttons: true,
              dangerMode: true,
            }).then((value) => {});
          } else {
            this.orderList.push(...data);
          }

          this.barcodeDialog = false;
        });
      } else {
        orderService.getOrderById(code).then((data) => {
          this.orderList = this.orderList.filter((v) => false);
          console.log(data);
          if (
            data != null &&
            data.length != 0 &&
            data[0].statusDate == "Block"
          ) {
            this.$swal({
              title: "Already Assign!",
              text: "Assign person " + data[0].assignName,
              icon: "warning",
              buttons: true,
              dangerMode: true,
            }).then((value) => {});
          } else if (
            data != null &&
            data.length != 0 &&
            data[0].statusDate == "OtherBranch"
          ) {
            this.$swal({
              title: "Your branch is not same with to branch!",
              text: "To branch name " + data[0].toBranchName,
              icon: "warning",
              buttons: true,
              dangerMode: true,
            }).then((value) => {});
          } else {
            this.orderList.push(...data);
          }

          this.barcodeDialog = false;
        });
      }
    },
  },
  computed: {
    toDateValue() {
      var toDatetemp = "";
      toDatetemp = this.formatDate(this.toDate);
      return toDatetemp;
    },
    fromDateValue() {
      var fromDatetemp = "";
      fromDatetemp = this.formatDate(this.fromDate);
      return fromDatetemp;
    },
  },
  filters: {
    removeTime: function (value) {
      if (value != undefined) {
        return value.split(" ")[0];
      }
      return "";
    },
    groupStatus: function (value = []) {
      //let status = [0, 0, 0, 0, 0]; //Order, Collected, 	To Collect
      let statusMap = new Map();
      let status = "";
      value.forEach((v) => {
        if (statusMap.has(v.statusDate)) {
          let val = statusMap.get(v.statusDate);
          statusMap.set(v.statusDate, ++val);
        } else {
          statusMap.set(v.statusDate, 1);
        }
      });
      for (const [k, v] of statusMap.entries()) {
        status += ` ${k} : ${v} |`;
      }
      return status;
    },
    priceTotal: function (items = []) {
      let total = 0;
      items.forEach((v) => {
        total += v.payment;
      });
      return total;
    },
  },
  components: {
    "bar-code-view": BarCodeScanView,paymentDialog,orderHistoryDialog
  },
};
</script>


<style scoped>
/* .tbl-info table,
.tbl-info td,
.tbl-info th {
  padding: 2px;
}

.tbl-info thead th,
.tbl-info thead td {
  font-size: 14px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 1px;
  padding-right: 3px;
  border: 1px solid #e0e0e0;
  background: #4caf50 !important;
  text-align: center !important;
  color: white !important;
}

.tbl-info tbody th,
.tbl-info tbody td {
  font-size: 13px;
  padding-left: 1px;
  border: 1px solid #e7e7e7;
  padding-right: 1px;
} */

.foot-summary {
  background: #4caf50 !important;
  color: white;
}
.v-data-table td,
.v-data-table th {
  padding: 0 0px !important;
}
</style>